import { instanceToPlain, plainToInstance, } from 'class-transformer';
export class TransformerWrapper {
    static plainToInstance(cls, plain, options) {
        return plainToInstance(cls, plain, options);
    }
    static instanceToPlain(object, options) {
        return instanceToPlain(object, options);
    }
}
//# sourceMappingURL=transformer.js.map